import { getDashboardResultsUrl, getResultErrorsUrl } from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class DashboardService {
  static getDashboardResults = (
    LOType,
    subject,
    mode,
    terms = [],
    courseLevels = [],
    masteryResults = null,
    categories = [],
    context,
    courseIds = [],
    variety = null,
    offeringIds = [],
    finalized = false,
    signal = null
  ) => {
    const params = { outcomeType: LOType, mode: mode };
    if (subject) {
      params.academicSubject = subject;
    }
    if (variety && variety.length === 1) {
      params.variety = variety[0];
    }
    if (terms?.length > 0) {
      const intTerms = []; // term ids should be strings for selector but ints for backend
      terms.forEach((term) => intTerms.push(parseInt(term)));
      params.termIds = intTerms;
    }
    if (courseLevels?.length > 0) {
      params.courseLevels = courseLevels;
    }
    if (masteryResults === "true") {
      params.masteryResults = masteryResults;
    }
    if (categories?.length > 0) {
      params.categoryIds = categories;
    }
    if (context) {
      params.contextType = context;
    }
    if (courseIds?.length > 0) {
      params.courseIds = courseIds;
    }
    if (offeringIds?.length > 0) {
      params.offeringIds = offeringIds;
    }
    if (finalized) {
      params.finalized = finalized;
    }
    return getRequest(getDashboardResultsUrl(), params, false, signal);
  };

  // update to reflect ExternalService version if want to use. Not currently used
  // static getAssessmentResults = (
  //   assignmentIds,
  //   mode,
  //   masteryResults,
  //   context
  // ) => {
  //   const params = { assignmentIds: assignmentIds, mode: mode };
  //   if (masteryResults === "true") {
  //     params.masteryResults = masteryResults;
  //   }
  //   if (context) {
  //     params.contextType = context;
  //   }
  //   return getRequest(getDashboardResultsUrl() + "/assessment", params);
  // };

  // currently not being used, but might use later
  // static getAssignmentResults = (id) => {
  //   const params = { id: id };
  //   return getRequest(getAssignmentResultsUrl(), params);
  // };
  static getResultErrors = (sectionId) => {
    return getRequest(getResultErrorsUrl(sectionId));
  };
}
